module.exports = __webpack_public_path__ + "static/media/pimso.d33da110.jpeg";